import { ReactNode } from 'react'

import { DEFAULT_FORMATTER_LOCALE } from '../../../../constants/defaultFormatterLocale'
import { NumberFormat } from '../../../../utils/NumberFormat'
import { FormattedElement } from '../../../elements/FormattedElement'
import { FormattedNumberProps } from '../../FormattedNumber'

export type FormattedPercentNumberProps = FormattedNumberProps

export const FormattedPercentNumber = ({
  as = 'span',
  asString = false,
  locale = DEFAULT_FORMATTER_LOCALE,
  options,
  value,
}: FormattedPercentNumberProps): ReactNode => {
  return (
    <FormattedElement as={as} asString={asString}>
      {NumberFormat.getPercentNumber(value, locale, options)}
    </FormattedElement>
  )
}
